<template>
  <v-icon small class="mr-1" v-if="hasEditAccess" @click="$parent.$parent.$parent.editItem(editingItem)">edit</v-icon>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      editingItem: this.item
    }
  }
}
</script>